/**
 * Accepts a Date object or date string that is recognized by the Date.parse() method
 */
export function getDayOfWeek(
    date: Date | string,
    style: 'short' | 'long' = 'long'
): string | null {
    const dayOfWeek = new Date(date).getUTCDay();
    switch (style) {
        case 'short':
            return isNaN(dayOfWeek)
                ? null
                : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][dayOfWeek];
        case 'long':
            return isNaN(dayOfWeek)
                ? null
                : [
                      'Sunday',
                      'Monday',
                      'Tuesday',
                      'Wednesday',
                      'Thursday',
                      'Friday',
                      'Saturday',
                  ][dayOfWeek];
    }
}
